import { BaseService, Service } from "/@/cool";
@Service("messageList")
class MessageList extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["add"] = prefix + "add";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["list"] = prefix + "list";
		this.permission["update"] = prefix + "update";
		this.permission["updateMessageRecordStatus"] = prefix + "updateMessageRecordStatus";
		this.permission["roleOptions"] = prefix + "roleOptions";
		this.permission["publish"] = prefix + "add";
	}

	roleOptions(data: { app_id: number }) {
		return this.request({
			url: "/roleOptions",
			method: "GET",
			params: data
		});
	}

	publish(data: { id: number }) {
		return this.request({
			url: "/publish",
			method: "POST",
			data
		});
	}

	getMessageById(data: { id?: number }) {
		return this.request({
			url: "/info",
			method: "POST",
			data
		});
	}

	getMessageList(data: { nums?: number }) {
		return this.request({
			url: "/list",
			method: "POST",
			data
		});
	}

	updateMessageStatus(data: {}) {
		return this.request({
			url: "/updateMessageRecordStatus",
			method: "POST",
			data
		});
	}
}
export default MessageList;
